const baseStyle = {
  fontWeight: 700,
};

const darkOrangeStyle = {
  ...baseStyle,
  backgroundColor: '#B06207',
  color: '#FFFFFF',
};

const redStyle = {
  ...baseStyle,
  backgroundColor: '#E01A2B',
  color: '#FFFFFF',
};

const blackStyle = {
  ...baseStyle,
  backgroundColor: '#000000',
  color: '#FFFFFF',
};

const defaultStyle = darkOrangeStyle;

const customStyledBadges = new Map([
  ['new markdown', redStyle],
  ['today only', redStyle],
  ['our lowest price', redStyle],
  ['black friday special', blackStyle],
  ['cyber monday special', blackStyle],
  ['black friday deal', blackStyle],
  ['cyber monday deal', blackStyle],
]);

const listOfBlockedBadges = new Set(['last act', 'closeout']);

export default function useSpecialOffersBadge() {
  /** @param {string} text Badge text */
  /** @returns {object} */
  function getStyleForBadgeWithThisText(text) {
    return customStyledBadges.has(text.toLowerCase()) ? customStyledBadges.get(text.toLowerCase()) : defaultStyle;
  }

  /** @param {string} text Badge text */
  /** @returns {boolean} */
  function doShowBadgeForThisText(text) {
    return text && typeof text === 'string' && !listOfBlockedBadges.has(text.toLowerCase());
  }

  /** @param {string} badgeText Badge text */
  /** @param {string} brand Brand ("mcom" or "bcom") */
  /** @returns {object} Special Offers Badge type */
  function getSpecialOffersBadgeSettings(badgeText, brand) {
    return {
      enableBadge: brand === 'mcom' && doShowBadgeForThisText(badgeText),
      badgeText,
      styles: getStyleForBadgeWithThisText(badgeText),
      classesApplied: [],
    };
  }

  return {
    getSpecialOffersBadgeSettings,
  };
}
